<div class="add-base-container">
  <mat-card>
    <mat-card-title>
      <p class="card-inner-title">
        Aggiungi base
      </p>
    </mat-card-title>
    <mat-card-content class="base-container">
      <form
        class="base-general"
        *ngIf="entityForm"
        [formGroup]="entityForm"
      >
        <mat-tab-group animationDuration="0ms">
          <mat-tab [label]="'Generali' | translate">
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="codiceUnico"
                [placeholder]="'Codice Unico' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="titolo"
                [placeholder]="'Titolo' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="number"
                matInput
                formControlName="altezza"
                [placeholder]="'Altezza' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="number"
                matInput
                formControlName="larghezza"
                [placeholder]="'Larghezza' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="number"
                matInput
                formControlName="profondita"
                [placeholder]="'Profondità' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="number"
                matInput
                formControlName="peso"
                [placeholder]="'Peso' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <textarea
                class="input-expanse"
                matInput
                formControlName="note"
                [placeholder]="'Note' | translate"></textarea>
            </mat-form-field>

            <h3>{{ 'Materiale' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['Base']">
              <p>
                {{ 'Inserisci uno o più materiali.' | translate }}
              </p>
              <ui-input-repeatable [form]="entityForm?.get('materiale')">
                <ng-template
                  let-item="item"
                  let-index="index">
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Aggiungi materiale"
                      [formControl]="item">
                  </mat-form-field>
                </ng-template>
              </ui-input-repeatable>
            </ng-container>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['Base']; behaviour: 'show'">
              <p>{{ 'Materiali presenti' | translate }}</p>
              <ul>
                <li *ngFor="let m of entityForm?.get('materiale')?.controls || []">{{ m.value }}</li>
              </ul>
            </ng-container>

            <h3>{{ 'Dimensioni Varie' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['Base']">
              <p>
                {{ 'Inserisci uno o più dimensione.' | translate }}
              </p>
              <ui-input-repeatable [form]="entityForm?.get('dimensioniVarie')">
                <ng-template
                  let-item="item"
                  let-index="index">
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Dimensione"
                      [formControl]="item">
                  </mat-form-field>
                </ng-template>
              </ui-input-repeatable>
            </ng-container>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['Base']; behaviour: 'show'">
              <p>
                {{ 'Dimensioni varie presenti' | translate }}
              </p>
              <ul>
                <li *ngFor="let d of entityForm?.get('dimensioniVarie')?.controls || []">{{ d.value }}</li>
              </ul>
            </ng-container>

            <h3>{{ 'Tag' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['Base']">
              <p>
                {{ 'Inserisci uno o più tag.' | translate }}
              </p>
              <ui-input-repeatable [form]="entityForm?.get('tag')">
                <ng-template
                  let-item="item"
                  let-index="index">
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Tag"
                      [formControl]="item">
                  </mat-form-field>
                </ng-template>
              </ui-input-repeatable>
            </ng-container>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['Base']; behaviour: 'show'">
              <p *ngIf="(entityForm?.get('tag')?.controls || []).length > 0">{{ 'Tag presenti' | translate }}</p>
              <p
                *ngIf="(entityForm?.get('tag')?.controls || []).length === 0">{{ 'Nessun tag presente' | translate }}</p>
              <ul>
                <li *ngFor="let t of entityForm?.get('tag')?.controls || []">{{ t.value }}</li>
              </ul>
            </ng-container>
          </mat-tab>
          <mat-tab [label]="'Allegati' | translate">
            <app-attachments-manager
              [form]="entityForm.get('allegati')"
              [classNames]="['Base']">
            </app-attachments-manager>
          </mat-tab>
          <mat-tab [label]="'Beni correlati' | translate">
            <app-base-cards [base]="entityForm?.value"></app-base-cards>
          </mat-tab>
        </mat-tab-group>

        <div class="base-actions">
          <button
            *roleVisibility="['create', 'update']; classNames: ['Base']"
            mat-raised-button
            color="primary"
            (click)="createAndAddToObject()"
          >
            Crea ed e aggiungi
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
